const statusChipColor = (status, classes) => {
  if (status) {
    return classes.active
  }

  return classes.inactive
}

export default statusChipColor
